import {
    Col,
    message,
    PageHeader,
    Row,
    Spin,
    Select,
    Space,
    Tabs,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
import {
    SelectItem,
    Form,
    FormItem,
    cuentaMask,
    TableItem,
    dineroDisabledMask,
    round2Decimals,
    ButtonItem,
    ErrorItem,
    DatePickerItem,
    SelectCuentaContableItem
} from "../../../../Components/Items";
import { FileExcelOutlined, FilePdfOutlined, FileTextOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
import "moment/locale/es";
import reporteDeBalanzaDeComprobacionPdf from "../../../../Pdf/reporteDeBalanzaDeComprobacionPdf";

moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;

class ReporteBalanzaDeComprobacionContabilidadElectronica extends Component {
    state = {
        loading: false,
        pdf: null,
        objetoProyectos: null,
        todasProyectos: null,
        objetoUniadesDeNegocio: null,
        todasUniadesDeNegocio: null,
        dataReporte: null,
        todasCuentas: [],
    };

    atras() {
        this.props.history.goBack();
    }

    async componentDidMount() {
        this.setState({ loading: true });
        await axios
            .post(
                "proyectos/selectProyectos",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    this.setState({ todasProyectos: res.data });
                    this.setState({
                        objetoProyectos: res.data.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                    });
                }
            });
        await axios
            .post(
                "unidadesdenegocio/selectUnidadesDeNegocio",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    this.setState({ todasUniadesDeNegocio: res.data });
                    this.setState({
                        objetoUniadesDeNegocio: res.data.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {cuentaMask(
                                        value.nivel1 +
                                        value.nivel2 +
                                        value.nivel3 +
                                        value.nivel4 +
                                        value.nivel5
                                    ) +
                                        " - " +
                                        value.nombre}
                                </Option>
                            );
                        }),
                    });
                }
            });
        this.consultarReporteContabilidadElectronica({
            periodo: [moment().subtract(1, "month"), moment()],
            nivel: 5,
        });
    }

    consultarReporteContabilidadElectronica(values) {
        this.setState({ loading: true });
        axios
            .post(
                "reportesFinancieros/reporteContabilidadElectronicaBalanza",
                { ...values, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        loading: false,
                        dataReporte: res.data,
                        todasCuentas: res.data.arrayCuentas.map(valueCuenta => {
                            return {
                                ...valueCuenta,
                                cuenta: cuentaMask(
                                    valueCuenta.nivel1 +
                                    valueCuenta.nivel2 +
                                    valueCuenta.nivel3 +
                                    valueCuenta.nivel4 +
                                    valueCuenta.nivel5
                                )
                            }
                        })
                    });
                } else if (res.data.success === 1) {
                    message.error("Ha sucedido un error y no se cargo bien el reporte");
                } else {
                    message.error("Ha sucedido un error y no se cargo bien el reporte");
                }
                this.setState({ loading: false });
            });
    }

    descargarExcel() {
        let datosDescargar = [];

        for (const valueCuenta of this.state.todasCuentas) {
            datosDescargar.push({
                Cuenta: valueCuenta.cuenta,
                Descripcion: valueCuenta.descripcion,
                'Saldo Inicial': round2Decimals(valueCuenta.saldoInicial),
                Cargos: round2Decimals(valueCuenta.totalCargos),
                Abonos: round2Decimals(valueCuenta.totalAbonos),
                'Saldo Final': round2Decimals(valueCuenta.saldoFinal),
            });
        }

        const worksheet = XLSX.utils.json_to_sheet(datosDescargar);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Contabilidad Electronica"
        );
        //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
        //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
        XLSX.writeFile(
            workbook,
            `Contabilidad_Electronica_${moment().locale("es").format("L")}.xlsx`
        );
    }

    descargarPdf() {
        pdfMake
            .createPdf(reporteDeBalanzaDeComprobacionPdf(this.state.dataReporte))
            .download(
                `Contabilidad_Electronica_${moment().locale("es").format("L")}`
            );
    }

    escapeXml(unsafe) {
        if (unsafe == null) return '';
        return String(unsafe)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&apos;');
    }

    descargarXMLBalanza() {
        const { todasCuentas, dataReporte } = this.state;

        const empresa = dataReporte?.empresa;

        const rfc = empresa?.rfc || '';
        const anio = dataReporte?.anio || '';
        const mes = dataReporte?.mes || '';
        const tipoEnvio = dataReporte?.tipoEnvio || 'N';

        const mesStr = String(mes).padStart(2, '0');
        const tipoEnvioFinal = tipoEnvio || 'N';

        // Filtrar solo cuentas de segundo nivel (ej. 100-01)
        const cuentasSegundoNivel = todasCuentas.filter(c => {
            if (!c.cuenta) return false;
            return c.cuenta.split('-').length === 2;
        });

        // Encabezado XML
        let xml = `<?xml version="1.0" encoding="UTF-8"?>\n`;
        xml += `<balanza:Balanza\n`;
        xml += `  xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"\n`;
        xml += `  xmlns:balanza="http://www.sat.gob.mx/esquemas/ContabilidadE/1_3/BalanzaComprobacion"\n`;
        xml += `  xsi:schemaLocation="http://www.sat.gob.mx/esquemas/ContabilidadE/1_3/BalanzaComprobacion http://www.sat.gob.mx/esquemas/ContabilidadE/1_3/BalanzaComprobacion/BalanzaComprobacion_1_3.xsd"\n`;
        xml += `  Version="1.3"\n`;
        xml += `  RFC="${this.escapeXml(rfc)}"\n`;
        xml += `  Mes="${mesStr}"\n`;
        xml += `  Anio="${anio}"\n`;
        xml += `  TipoEnvio="${tipoEnvioFinal}">\n\n`;

        // Cuentas (solo segundo nivel)
        for (const valueCuenta of cuentasSegundoNivel) {
            const saldoInicial = round2Decimals(valueCuenta.saldoInicial || 0);
            const debe = round2Decimals(valueCuenta.totalCargos || 0);
            const haber = round2Decimals(valueCuenta.totalAbonos || 0);
            const saldoFinal = round2Decimals(valueCuenta.saldoFinal || 0);

            xml += `  <balanza:Ctas\n`;
            xml += `    NumCta="${this.escapeXml(valueCuenta.cuenta)}"\n`;
            xml += `    SaldoIni="${Number(saldoInicial).toFixed(2)}"\n`;
            xml += `    Debe="${Number(debe).toFixed(2)}"\n`;
            xml += `    Haber="${Number(haber).toFixed(2)}"\n`;
            xml += `    SaldoFin="${Number(saldoFinal).toFixed(2)}" />\n`;
        }

        xml += `\n</balanza:Balanza>\n`;

        // Descargar archivo
        const blob = new Blob([xml], { type: 'application/xml;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.download = `B${rfc}${anio}${mesStr}.xml`;
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }


    onFinishFailed(e) {
        ErrorItem(e);
    }

    render() {
        const columns = [
            {
                title: "Cuenta",
                dataIndex: "cuenta",
                key: "cuenta",
                sorter: (a, b) => {
                    if (a.cuenta < b.cuenta) {
                        return -1;
                    }
                    if (a.cuenta > b.cuenta) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "cuenta",
                ellipsis: true,
            },
            {
                title: "Descripcion",
                dataIndex: "descripcion",
                key: "descripcion",
                sorter: (a, b) => {
                    if (a.descripcion < b.descripcion) {
                        return -1;
                    }
                    if (a.descripcion > b.descripcion) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "descripcion",
                ellipsis: true,
            },
            {
                title: "Saldo Inicial",
                dataIndex: "saldoInicial",
                key: "saldoInicial",
                sorter: (a, b) => {
                    if (a.saldoInicial < b.saldoInicial) {
                        return -1;
                    }
                    if (a.saldoInicial > b.saldoInicial) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "saldoInicial",
                render: (value) => dineroDisabledMask(value),
                align: "right",
                ellipsis: true,
            },
            {
                title: "Cargos",
                dataIndex: "totalCargos",
                key: "totalCargos",
                sorter: (a, b) => {
                    if (a.totalCargos < b.totalCargos) {
                        return -1;
                    }
                    if (a.totalCargos > b.totalCargos) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "totalCargos",
                render: (value) => dineroDisabledMask(value),
                align: "right",
                ellipsis: true,
            },
            {
                title: "Abonos",
                dataIndex: "totalAbonos",
                key: "totalAbonos",
                sorter: (a, b) => {
                    if (a.totalAbonos < b.totalAbonos) {
                        return -1;
                    }
                    if (a.totalAbonos > b.totalAbonos) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "totalAbonos",
                render: (value) => dineroDisabledMask(value),
                align: "right",
                ellipsis: true,
            },
            {
                title: "Saldo Final",
                dataIndex: "saldoFinal",
                key: "saldoFinal",
                sorter: (a, b) => {
                    if (a.saldoFinal < b.saldoFinal) {
                        return -1;
                    }
                    if (a.saldoFinal > b.saldoFinal) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "saldoFinal",
                render: (value) => dineroDisabledMask(value),
                align: "right",
                ellipsis: true,
            },
        ];
        return (
            <>
                <Form
                    ref={this.formRef}
                    name="reporteContabilidadElectronica"
                    onFinish={this.consultarReporteContabilidadElectronica.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                    inita
                >
                    <PageHeader
                        onBack={this.atras.bind(this)}
                        title="Reporte Balanza De Comprobacion - Contabilidad Electronica"
                        style={{
                            border: "1px solid rgb(235, 237, 240)",
                            backgroundColor: "white",
                            marginBottom: 10,
                        }}
                        extra={
                            <div style={{ display: "flex", justifyContent: "right" }}>
                                <Space>
                                    {this.state.dataReporte && (
                                        <ButtonItem
                                            blanco
                                            onClick={() => this.descargarXMLBalanza()}
                                            icon={<FileTextOutlined />}
                                            style={{ display: "block", margin: "0 0 0 auto" }}
                                        >
                                            Descargar Xml
                                        </ButtonItem>
                                    )}
                                    {this.state.dataReporte && (
                                        <ButtonItem
                                            blanco
                                            onClick={() => this.descargarExcel()}
                                            icon={<FileExcelOutlined />}
                                            style={{ display: "block", margin: "0 0 0 auto" }}
                                        >
                                            Descargar Excel
                                        </ButtonItem>
                                    )}
                                    {this.state.dataReporte && (
                                        <ButtonItem
                                            blanco
                                            onClick={() => this.descargarPdf()}
                                            icon={<FilePdfOutlined />}
                                            style={{ display: "block", margin: "0 0 0 auto" }}
                                        >
                                            Descargar PDF
                                        </ButtonItem>
                                    )}
                                    <ButtonItem
                                        type="primary"
                                        htmlType="submit"
                                        style={{ display: "block", margin: "0 0 0 auto" }}
                                    >
                                        Consultar
                                    </ButtonItem>
                                </Space>
                            </div>
                        }
                    />
                    <Spin spinning={this.state.loading}>
                        <div
                            style={{
                            backgroundColor: "white",
                            padding: 20,
                            paddingTop: 5,
                            borderRadius: 5,
                            boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                            }}
                        >
                            <Tabs
                                style={{ margin: 0 }}
                                tabBarExtraContent={{
                                    left: (
                                        <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                                            Filtros:
                                        </h1>
                                    ),
                                }}
                            >
                                <TabPane tabKey="3" key="3" forceRender tab="Mes">
                                    <FormItem initialValue={moment()} name="mesDate" required noStyle>
                                        <DatePickerItem
                                            picker="month"
                                            format="MM/YYYY"
                                            placeholder="Seleccionar mes"
                                        />
                                    </FormItem>
                                </TabPane>
                                <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                                    <Row>
                                        <Col span={8}>
                                            <FormItem
                                                name="filtrarProyecto"
                                                required
                                                noStyle
                                                initialValue={0}
                                            >
                                                <SelectItem width="90%" placeholder="Filtrar Proyecto">
                                                    <Option default value={0}>
                                                        Niguno
                                                    </Option>
                                                    <Option value={1}>Proyectos</Option>
                                                    <Option value={2}>Unidades de negocio</Option>
                                                </SelectItem>
                                            </FormItem>
                                        </Col>
                                        <Col span={8}>
                                            <FormItem shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                    const filtrarProyecto =
                                                        getFieldValue("filtrarProyecto");
                                                    if (filtrarProyecto === 1) {
                                                        return (
                                                            <FormItem required name="proyectos" noStyle>
                                                                <SelectItem
                                                                    width="90%"
                                                                    placeholder="Proyectos"
                                                                    mode="multiple"
                                                                >
                                                                    {this.state.objetoProyectos}
                                                                </SelectItem>
                                                            </FormItem>
                                                        );
                                                    }
                                                    if (filtrarProyecto === 2) {
                                                        return (
                                                            <FormItem
                                                                required
                                                                name="unidadDeNegocioId"
                                                                noStyle
                                                            >
                                                                <SelectItem
                                                                    width="90%"
                                                                    placeholder="Unidades de Negocio"
                                                                >
                                                                    {this.state.objetoUniadesDeNegocio}
                                                                </SelectItem>
                                                            </FormItem>
                                                        );
                                                    }
                                                }}
                                            </FormItem>
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabKey="5" key="5" forceRender tab="Nivel">
                                    <FormItem
                                        label="Nivel"
                                        name="nivel"
                                        required
                                        marginBottom="0px"
                                        initialValue={5}
                                    >
                                        <SelectItem placeholder="Nivel">
                                            <Option value={1}>Nivel 1</Option>
                                            <Option value={2}>Nivel 2</Option>
                                            <Option value={3}>Nivel 3</Option>
                                            <Option value={3}>Nivel 5</Option>
                                            <Option value={3}>Nivel 5</Option>
                                        </SelectItem>
                                    </FormItem>
                                </TabPane>
                                <TabPane tabKey="6" key="6" forceRender tab="Rango de Cuentas">
                                    <Row>
                                        <Col span={12}>
                                            <FormItem name="cuentaIdDesde" noStyle>
                                                <SelectCuentaContableItem
                                                    width="90%"
                                                    placeholder="Cuenta Desde"
                                                    allowClear
                                                    empresaId={this.props.empresaId}
                                                    headersToken={this.props.headersToken}
                                                />
                                            </FormItem>
                                        </Col>
                                        <Col span={12}>
                                            <FormItem name="cuentaIdHasta" noStyle>
                                                <SelectCuentaContableItem
                                                    width="90%"
                                                    placeholder="Cuenta Hasta"
                                                    allowClear
                                                    empresaId={this.props.empresaId}
                                                    headersToken={this.props.headersToken}
                                                />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                </TabPane>
                            </Tabs>
                        </div>
                        <h1 style={{ textAlign: "center" }}>Cuentas</h1>
                        <TableItem
                            columns={columns}
                            dataSource={this.state.todasCuentas}
                            size="small"
                            pagination={false}
                        />
                    </Spin>
                </Form>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(ReporteBalanzaDeComprobacionContabilidadElectronica);